import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProcessService } from 'src/app/services/process.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale, listLocales } from 'ngx-bootstrap/chronos';
// import { thBeLocale } from 'ngx-bootstrap/locale';

import * as Chart from 'chart.js';
import { FarmService } from 'src/app/services/farm-service.service';
import Swal from 'sweetalert2';
import * as moment from 'moment';
declare var $: any;

@Component({
  selector: 'smart-farm-history',
  templateUrl: './farm-history.component.html',
  styleUrls: ['./farm-history.component.css']
})
export class FarmHistoryComponent implements OnInit {


  constructor(
    ) {}

  ngOnInit() {

 
  }
  


}
